export default __webpack_public_path__ + "static/fastfocus-61397361d05496a08802facbc5df816f.svg";